"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Tab = function Tab(_ref) {
  var activeTab = _ref.activeTab,
      label = _ref.label,
      _onClick = _ref.onClick;
  var className = 'tabs__item';
  if (activeTab === label) className += ' tabs__item--active';
  return _react.default.createElement("li", {
    className: className,
    onClick: function onClick() {
      return _onClick(label);
    }
  }, label);
};

Tab.propTypes = {
  activeTab: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var _default = Tab;
exports.default = _default;